





























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Create from './Service/Create';
import DoModify from './Service/DoModify';
import Modify from './Service/Info';
import accountLists from './accountLists.vue';

import settingForm from './form';

@Component({
  components: { accountLists },
})
export default class configModify extends Vue {
  private form: any = {
    transaction_item: [''],
  };

  private settingForm: Object = settingForm;

  private dialogAccount: boolean = false;

  // 帳號列表
  private account: any = [];

  /**
   * getInfo 取得資料
   */
  public async getInfo() {
    const getter = (await new Modify({
      p3_ant_id: this.$route.query.p3_ant_id,
    }).get()) as any;
    this.form = getter;
    this.account = getter.ttl_exclude_account;
  }

  private handleClose(index: number) {
    this.account.splice(index, 1);
  }

  private pushAccount(data: any) {
    const find = this.account.find((x: any) => x.p3_ant_id === data.p3_ant_id);
    if (!find) {
      this.account.push(data);
      const msg: any = this.$t('Util.createComplete');
      this.$message.success(msg);
    }
  }

  /** 送出表單 */
  public async submitForm(formName: string) {
    /** 測試模式判定 */
    const myForm: any = this.$refs[formName];
    myForm.validate(async (valid: boolean) => {
      if (valid) {
        this.form.account = this.account;
        const getter = (await new DoModify(this.form).put()) as any;
        if (getter.data && getter.data.code === 0) {
          this.getInfo();
        }
      } else {
        const msg: any = this.$t('Util.validateError');
        this.$message.error(msg);
      }
    });
  }

  private addItem() {
    this.form.transaction_item.push('');
  }

  private delItem(index: number) {
    this.form.transaction_item.splice(index, 1);
  }

  /** 清除表單 */
  private resetForm(formName: string) {
    const myForm: any = this.$refs[formName];
    myForm.resetFields();
  }

  private mounted() {
    this.getInfo();
    this.$bus.$on('info', () => {
      this.$router.push(`/fedCustom/config/info`);
    });
    this.$bus.$on('save', () => {
      this.submitForm('form');
    });
  }
}
